"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOND_ROLE_FILTER = void 0;
const BOND_ROLE_PREFIX = 'Bond';
exports.BOND_ROLE_FILTER = `${BOND_ROLE_PREFIX}%`;
//# sourceMappingURL=role.consts.js.map